// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@plumberssupply/XDL/types";
import { color } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        css: css`
            input {
                margin-left: 0;

                & + label {
                    line-height: 24px;
                }

                & + label:before {
                    height: 14px;
                    width: 14px;
                }

                &:focus + label::before {
                    box-shadow: none;
                }

                &:checked:not(:disabled) + label::before {
                    background: transparent;
                }
                &:checked + label::after {
                    height: 10px;
                    width: 10px;
                    background: ${color("common.ui16")};
                    left: 2px;
                    top: initial;
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                    &::before {
                        border-color: ${color("common.ui1")};
                    }
                }
            }
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        css: css`
            & > ${TypographyStyle as any} {
                padding: 0;
                margin-bottom: 10px;
                &:last-child,
                &:empty {
                    margin-bottom: 0;
                }
            }
        `,
    },
} as xBaseTheme["radio"];
